import { jsx as _jsx } from "react/jsx-runtime";
import { Textarea as FluentTextarea, makeStyles } from "@fluentui/react-components";
const useInputStyles = makeStyles({
    textarea: {
        minHeight: "100px",
        maxHeight: "500px",
    },
});
/**
 * This is a texarea box that stops propagation of change/keydown events
 * @param props
 * @returns
 */
export const Textarea = (props) => {
    Textarea.displayName = "Textarea";
    const classes = useInputStyles();
    const handleChange = (event, _data) => {
        event.stopPropagation(); // Prevent event propagation
        if (props.onChange) {
            props.onChange(event.target.value); // Call the original onChange handler passed as prop
        }
    };
    const handleKeyDown = (event) => {
        event.stopPropagation(); // Prevent event propagation
    };
    return _jsx(FluentTextarea, { ...props, textarea: { className: classes.textarea }, onChange: handleChange, onKeyDown: handleKeyDown });
};
//# sourceMappingURL=textarea.js.map